import { Box, BoxProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import Typography from '@ui/Typography';
import { ModalBodyPaper } from 'components/Modal';
import CircularLoader from 'components/LoadingIndicators/CircularLoader';

const useStyles = makeStyles()(theme => ({
  modalLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
  },
}));

interface DictionaryLoadingProps extends BoxProps {
  onClose: () => void;
  className: string;
}

const DictionaryLoading = ({
  onClose,
  className,
  ...restProps
}: DictionaryLoadingProps) => {
  const { classes, cx } = useStyles();
  return (
    <Box {...restProps}>
      <ModalBodyPaper
        includeDismissIcon={false}
        onClose={onClose}
        className={cx(className, classes.modalLoading)}
      >
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'center'}
          style={{ gap: 16 }}
        >
          <CircularLoader size={64} />
          <Typography variant="pSm">{`Finding suggestions`}</Typography>
        </Box>
      </ModalBodyPaper>
    </Box>
  );
};

export default DictionaryLoading;
